import React from 'react';
import PropTypes from 'prop-types';
import styles from './ribbon.module.scss';

export default function Ribbon({ className = '', content }) {
  return <span className={`${styles?.ribbon || ''} ${className}`}>{content}</span>;
}

Ribbon.propTypes = {
  className: PropTypes.string,
  content: PropTypes.string,
};
